<template>
    <div>
        <h3>
            Invoices
            <v-btn :disabled="isLoading"
                   @click="showInvoiceAddDialog = true"
                   class="text-none ml-2"
                   color="secondary darken-1"
                   fab
                   x-small>
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </h3>
        <v-card class="mt-5"
                no-gutters
                :loading="isLoading">
            <v-card-text>
                <v-simple-table dense fixed-header>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">
                                Invoice Number
                            </th>
                            <th class="text-left">
                                Invoice Date
                            </th>
                            <th class="text-left">
                                Due Date
                            </th>
                            <th class="text-left">
                                Total
                            </th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td>{{ invoice.documentNumber }}</td>
                            <td>{{ invoice.invoiceDate | moment("YYYY-MM-DD") }}</td>
                            <td>{{ invoice.dueDate | moment("YYYY-MM-DD") }}</td>
                            <td>{{ formatPrice(invoice.total) }}</td>
                            <td>
                                <v-btn icon
                                       x-small
                                       @click="downloadFile(invoice.fileId, invoice.documentNumber)">
                                    <v-icon dark>
                                        mdi-download
                                    </v-icon>
                                </v-btn>
                                <v-btn icon
                                       x-small
                                       @click="confirmDelete(invoice.id,invoice.documentNumber)">
                                    <v-icon color="red">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <company-invoice-add-dialog :show="showInvoiceAddDialog"
                                    :company-id="companyId"
                                    :payment-preference="paymentPreference"
                                    @invoice-created="onInvoiceCreated"
                                    @close="showInvoiceAddDialog=false"/>

        <v-dialog v-model="showConfirmDeleteDialog" max-width="350">
            <v-card>
                <v-card-title class="text-h5">
                    Delete the invoice?
                </v-card-title>

                <v-card-text>
                    {{ invoiceDeleteText }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue"
                           text
                           @click="cancelDeleteInvoice">
                        No
                    </v-btn>
                    <v-btn
                            text
                            @click="deleteInvoice()">
                        Yes
                    </v-btn>


                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import invoiceService from '@/services/invoice.service.js';
import fileService from "@/services/file.service";
import CompanyInvoiceAddDialog from "@/components/widgets/CompanyInvoices/CompanyInvoiceAddDialog.vue";

export default {
    name: "CompanyInvoicesList",
    components: {CompanyInvoiceAddDialog},
    props: ['companyId', 'accountNumber',"paymentPreference"],
    data() {
        return {
            isLoading: false,
            invoices: null,
            invoiceDeleteText: "Are you sure you want to delete the invoice?",
            invoiceToDeleteId: null,
            showInvoiceAddDialog: false,
            showConfirmDeleteDialog: false,
        }
    },
    methods: {
        async fetchData() {
            this.isLoading = true;
            if (this.companyId) {
                this.invoices = await invoiceService.getlist(this.companyId);
            }
            this.isLoading = false;
        },
        onInvoiceCreated() {
            this.showInvoiceAddDialog = false;
            this.fetchData();
        },
        downloadFile(fileId, documentNumber) {
            let fullDowloadFileName = documentNumber;
            if (this.accountNumber) {
                fullDowloadFileName = `${this.accountNumber}_${documentNumber}`
            }
            fileService.get(fileId, fullDowloadFileName);
        },
        confirmDelete(invoiceId, documentNumber) {
            this.invoiceToDeleteId = invoiceId;
            this.invoiceDeleteText = `Are you sure you want to delete invoice ${documentNumber}?`;
            this.showConfirmDeleteDialog = true;
        },
        async deleteInvoice() {
            this.isLoading = true;
            await invoiceService.delete(this.invoiceToDeleteId);
            await this.fetchData();
            this.showConfirmDeleteDialog = false;
        },
        cancelDeleteInvoice(){
            this.showConfirmDeleteDialog = false;
            this.invoiceToDeleteId=null;
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2);
            return "R " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    async created() {
        this.isLoading = true;
        await this.fetchData();
        this.isLoading = false;
    },
}
</script>

<style scoped>

</style>
